import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export function AppContextTracker() {
    const location = useLocation();

    useEffect(() => {
        // Set environment tag using Vite's build mode
        Sentry.setTag('app_env', import.meta.env.MODE);
        // Clear the old app context tag
        Sentry.setTag('app_context', null);

        // Simple path matching for our major areas
        const path = location.pathname;

        if (path.startsWith('/event/') || path.startsWith('/events/')) {
            Sentry.setTag('app_context', 'eventPage');
        } else if (path.startsWith('/seller/')) {
            Sentry.setTag('app_context', 'sellerPage');
        } else if (path.startsWith('/dashboard/')) {
            Sentry.setTag('app_context', 'dashboard');
        } else if (path.startsWith('/ticket/')) {
            Sentry.setTag('app_context', 'ticketPage');
        } else if (path.startsWith('/scanner/')) {
            Sentry.setTag('app_context', 'scanner');
        } else {
            Sentry.setTag('app_context', 'unknown');
        }
    }, [location.pathname]);

    return null; // This component doesn't render anything
} 